import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateFormatPipe'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'yyyy-MM-dd H:mm');
    return value;
  }
  transformTOWords(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'MMM d,y h:mm a');
    return value;
  }
   monthTransform(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'MMM d,y');
     return value;
   }
   dateTransform(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'dd-MMM-yyyy');
     return value;

   }
   simpledateFormat(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'dd-MM-yyyy');
     return value;

   }
   simpledateFormatWithTime(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'dd-MM-yyyy h:mm a');
     return value;
   }
   transformdatetimelocale(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value,  'dd/mm/yyyy, H:mm');
     return value;

   }
   transformDefault(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value,  'dd/mm/yyyy');
     return value;

   }
   transformToLocalDate(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value,  'yyyy-MM-dd');
     return value;

   }
   transformToLocalTime(value: any) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value,  'h:mm a');
     return value;

   }
}
